import {
  addUtcDays,
  addUtcMonths,
  createUTCDate,
  localDateToUtcDate,
  printDateMonthAndYear
} from '@/helpers/dateHelper';
import { LeaveAllowancePeriod } from '@/services/gql/graphql.generated';

export const YEARLY = LeaveAllowancePeriod.PerYear;
export const MONTHLY = LeaveAllowancePeriod.PerMonth;

export const periodStartDate = (period: LeaveAllowancePeriod, date: Date, leaveYearStartMonth = 1): Date => {
  if (period !== YEARLY) return createUTCDate(date.getUTCFullYear(), date.getUTCMonth(), 1);

  const startMonth = leaveYearStartMonth - 1;
  const year = date.getUTCMonth() >= startMonth ? date.getUTCFullYear() : date.getUTCFullYear() - 1;
  return createUTCDate(year, startMonth, 1);
};

export const currentPeriodStart = (period: LeaveAllowancePeriod, leaveYearStartMonth = 1): Date =>
  periodStartDate(period, localDateToUtcDate(new Date()), leaveYearStartMonth);

export const shiftPeriod = (period: LeaveAllowancePeriod, periodStart: Date, delta: number): Date =>
  addUtcMonths(periodStart, period === YEARLY ? delta * 12 : delta);

export const formatPeriod = (period: LeaveAllowancePeriod, periodStart: Date): string => {
  if (period !== YEARLY) return printDateMonthAndYear(periodStart);

  const periodEnd = addUtcDays(addUtcMonths(periodStart, 12), -1);
  return `${printDateMonthAndYear(periodStart)} - ${printDateMonthAndYear(periodEnd)}`;
};

export const isValidAmount = (text: string): boolean => {
  if (text.trim() === '') return false;
  const value = Number(text);
  return Number.isInteger(value) && value >= 0;
};

export const editKey = (period: LeaveAllowancePeriod, periodStart: string, leaveTypeId: string): string =>
  `${period}|${periodStart}|${leaveTypeId}`;

export interface LeaveBalanceEdit {
  period: LeaveAllowancePeriod;
  periodStart: string;
  leaveTypeId: string;
  amount: string;
  isRecurring: boolean;
}

// Parses a ?year=yyyy query param, or undefined if missing/invalid.
export const parseYearParam = (value: string | null): number | undefined =>
  value && /^\d{4}$/.test(value) ? Number(value) : undefined;

// Start of the leave year labelled `year` under the current leave year start month.
export const leaveYearStart = (year: number, leaveYearStartMonth: number): Date =>
  createUTCDate(year, leaveYearStartMonth - 1, 1);
